import styled from 'styled-components';

import inviteLinksUnderlay from '../../assets/images/referralBack.png';

export const DashboardNotificationComponent = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const NotificationPill = styled.div`
  background: ${(props) => props.theme.colors.secondaryBlue};
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 12px;
  color: ${(props) => props.theme.colors.neutral500};
  text-transform: uppercase;
  font-size: 12px;
  line-height: 140%;
  display: inline-flex;
  font-weight: 500;
`;

export const IconTitleStyled = styled.h1`
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
  color: ${(props) => props.theme.colors.neutral900};
  margin-bottom: 24px;

  display: flex;
  align-items: center;

  img {
    margin-right: 12px;
    width: 40px;
  }

  @media (max-width: 800px) {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 16px;
    img {
      width: 32px;
    }
  }
`;

export const CashBackFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const RedCircle = styled.div`
  height: 280px;
  aspect-ratio: 1 / 1;
  border: 3px solid ${(props) => props.theme.colors.error500};
  padding: 3px;
  border-radius: 50%;
  > div {
    width: 100%;
    height: 100%;
    border: 30px solid ${(props) => props.theme.colors.error500};
    border-radius: 50%;
    aspect-ratio: 1 / 1;
  }
`;

export const EarningsSmall = styled.div<{ earnings?: string }>`
  display: grid;
  width: 100%;

  grid-template-columns: ${(props) =>
    props.earnings ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'};

  grid-column-gap: 24px;
  grid-row-gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 335px) {
    grid-template-columns: repeat(1, 1fr);
  }
  > div {
    cursor: pointer;
  }
  @media (max-width: 800px) {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    > div {
      padding: 12px;
    }
  }
`;

export const Statistical = styled(EarningsSmall)`
  > div {
    cursor: pointer;
    img {
      margin-right: 16px;
      width: 32px;
    }
  }
`;

export const BackOfficeNumbersWrap = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    width: calc(50% - 20px);

    > div {
      box-shadow: ${(props) => props.theme.shadows.shadowXS};
      background: ${(props) => props.theme.colors.neutral50};
      border-radius: 12px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    @media (max-width: 800px) {
      width: 100%;
      margin-bottom: 20px;
    }
  }
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const BackOfficeNumbers = styled.div<{ orange?: boolean }>`
  width: calc(100% / 8 - 6px);
  background: ${(props) =>
    props.orange
      ? (props) => props.theme.colors.secondary100
      : (props) => props.theme.colors.primary900};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 36px;
  line-height: 42px;
  color: ${(props) =>
    props.orange
      ? (props) => props.theme.colors.neutral50
      : (props) => props.theme.colors.neutral50};
  height: 56px;
  @media (max-width: 800px) {
    font-size: 16px;
    line-height: 20px;
    height: 36px;
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: ${(props) => props.theme.colors.neutral900};
  margin-bottom: 8px;
  @media (max-width: 800px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const Subtitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral500};
  margin-bottom: 40px;
`;

export const Image = styled.img`
  width: 160px;
  margin-bottom: 40px;
`;

export const Username = styled.div`
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 12px 12px;
  background: ${(props) => props.theme.colors.neutral50};
  border-radius: 22px;
  opacity: 0.95;
  width: 100%;
`;

export const CountdownNumbers = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  /* flex-direction: column; */
  justify-content: center;
  > div {
    width: 56px;
    margin: 7px;
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
      color: ${(props) => props.theme.colors.error500};
    }
    @media (max-width: 800px) {
      width: calc(25% - 30px);
    }
  }
  img {
    width: 100%;
  }
`;

export const IconPosition = styled.div`
  display: flex;
  align-self: start;
`;

export const SlideWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
  img {
    width: 100%;
  }

  .swiper-button-next,
  .swiper-button-next::after,
  .swiper-button-prev,
  .swiper-button-prev::after {
    color: ${({ theme }) => theme.colors.primary900};
    font-size: 30px;
  }
`;

export const TopPerformerComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopPerformerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InviteLinksUnderlay = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: url(${inviteLinksUnderlay}) no-repeat center center;
  background-size: cover;
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const InviteLinks = styled.div`
  width: 100%;
  border-radius: 200px;
  background: ${(props) => props.theme.colors.primary900};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
`;

export const ReferralLink = styled.div`
  width: 100%;
  border-radius: 200px;
  background: ${(props) => props.theme.colors.neutral100};
  padding: 10px 20px;
  word-break: break-all;
`;
